import {Languages} from "../../components/common/Texts";
import {getToken} from "../../auth";

const INITIAL_STATE = {
  companies: [],
  company: {},
  username: '',
  loggedIn: false,
  first_name: '',
  last_name: '',
  email: '',
  is_staff: false,
  is_superuser: false,
  language: Languages.es
}

const user = (state = INITIAL_STATE, action) => {
  const payload = action.payload;
  switch (action.type) {
    case 'persist/REHYDRATE':
      if (payload === undefined || payload.user === undefined)
        return state;

      return {
        ...state,
        ...payload.user,
        loggedIn: !!getToken(),
      };
    case "SET_LOGGED_IN":
      return {
        ...state,
        username: payload.username,
        loggedIn: true,
      }

    case "SET_TALENT_USER": {
      const data = payload.user
      if (!data) return state;
      return {
        ...state,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        is_staff: data.is_staff,
        is_superuser: data.is_superuser,
      }
    }

    case "LOG_OUT":
      return {
        ...state,
        username: '',
        loggedIn: false,
        company: {},
      }
    case "SET_LANGUAGE":
      return {
        ...state,
        language: payload,
      }

    case "SET_COMPANY": {
      const departments = payload.departments;
      const positions = payload.positions;
      const business_units = payload.business_units;
      const grupos_internos = payload.grupos_internos;

      const company = {
        id: payload.id,
        address: payload.address,
        name: payload.name,
        departments,
        positions,
        business_units,
        grupos_internos,
        dep_count: departments.length,
        pos_count: positions.length,
        bu_count: business_units.length,
        gi_count: grupos_internos.length,
        chart: payload.chart,
        potential_ruleset: payload.potential_ruleset || null,
        dynamic_fields: Array.isArray(payload.dynamic_fields) ? payload.dynamic_fields : [],
        credits: Number.isFinite(payload.credits) ? payload.credits : null,
      }

      return {
        ...state,
        company: company,
      }
    }
    default: {
      return state;
    }
  }
};

export default user;